<template>
    <toolbar-option v-if="isEnabled" :message="message">
        <template slot="primary">
            <dropdown
                :options="options"
                :value="value"
                native
                @input="onInput"
                @change="setChangedData(true)"
            />

            <div v-if="isCustom">
                <br>

                <input
                    type="text"
                    placeholder="Regular Expression"
                    :value="pattern"
                    @input="onCustomInput"
                    @change="setChangedData(true)"
                >
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import REGEX from '@/data/constants/regex';

const DEFAULT_VALUE = '';

export default {
    name: 'input-validation',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Validation',
            isCustom: false,
            isEnabled: true,
            message: '* If the field does not pass the specified validation option, the form submission will be blocked.',
            pattern: REGEX.ALL,
            value: DEFAULT_VALUE,
        };
    },

    computed: {
        options() {
            return [
                { text: 'None', value: '' },
                { text: 'Letters Only', value: 'letters' },
                { text: 'Numbers Only', value: 'numbers' },
                { text: 'Email', value: 'email' },
                { text: 'US Telephone', value: 'telephone' },
                { text: 'URL', value: 'url' },
                { text: 'Custom', value: 'custom' },
            ];
        },
    },

    watch: {
        changedOption({ option, value }) {
            if (option === 'input-type') {
                switch (value) {
                    case 'tel':
                        this.pattern = REGEX.US_PHONE_NUMBER;
                        break;

                    // let the browser handle validation natively for url and email inputs
                    case 'url':
                    case 'email':
                        this.pattern = '';
                        break;

                    default:
                        this.pattern = REGEX.ALL;
                }

                this.selectedElements[0].patternNew = this.pattern;
                this.value = '';
                this.isEnabled = value === 'text';
            }
        },
    },

    methods: {
        onSelectedElement() {
            const pattern = this.selectedElements[0].patternNew || DEFAULT_VALUE;

            this.pattern = pattern;
            this.isCustom = false;

            switch (pattern) {
                case REGEX.LETTERS_ONLY:
                    this.value = 'letters';
                    break;

                case REGEX.NUMBERS_ONLY:
                    this.value = 'numbers';
                    break;

                case REGEX.US_PHONE_NUMBER:
                    this.value = 'telephone';
                    break;

                case REGEX.ALL:
                    if (this.selectedElements[0].inputTypeNew === 'email') {
                        this.value = 'email';
                    } else if (this.selectedElements[0].inputTypeNew === 'url') {
                        this.value = 'url';
                    } else {
                        this.value = '';
                    }
                    break;

                case '':
                    this.value = '';
                    break;

                default:
                    this.value = 'custom';
                    this.isCustom = true;
                    break;
            }
        },

        onInput(valueNew) {
            this.value = valueNew;
            this.isCustom = false;

            this.selectedElements[0].inputTypeNew = 'text';

            switch (valueNew) {
                // the input type option will switch to "text" when this is selected
                case 'letters':
                    this.pattern = REGEX.LETTERS_ONLY;
                    break;

                // the input type option will switch to "text" when this is selected
                case 'numbers':
                    this.pattern = REGEX.NUMBERS_ONLY;
                    break;

                // the input type option will switch to "tel" when this is selected
                case 'telephone':
                    this.pattern = REGEX.US_PHONE_NUMBER;
                    this.selectedElements[0].inputTypeNew = 'tel';
                    break;

                // leave pattern empty, and rely on native validation
                // the input type option will switch to "email" when this is selected
                case 'email':
                    this.pattern = '';
                    this.selectedElements[0].inputTypeNew = 'email';
                    break;

                // leave pattern empty, and rely on native validation
                // the input type option will switch to "url" when this is selected
                case 'url':
                    this.pattern = DEFAULT_VALUE;
                    this.selectedElements[0].inputTypeNew = 'url';
                    break;

                case 'custom':
                    this.pattern = DEFAULT_VALUE;
                    this.isCustom = true;
                    break;

                default:
                    this.pattern = DEFAULT_VALUE;
            }

            this.selectedElements[0].patternNew = this.pattern || DEFAULT_VALUE;
            this.onOptionChange(valueNew);
            this.setChangedData(true);
        },

        onCustomInput(e) {
            this.pattern = e.target.value;
            this.selectedElements[0].patternNew = this.pattern || DEFAULT_VALUE;
            this.setChangedData(true);
        },
    },
};
</script>
